import React from 'react';
import { Dialog, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { ConnectedCheckoutPage } from './CheckoutPage';
import { COLORS } from '../storefront/storefrontStyles';

// El checkout del carrito, en un diálogo a pantalla completa sobre /call o
// sobre el vivo (`live`: sin llamada a la que vincular el pedido).
//
// Navegar a /checkout/:storeId desmontaría Call.js y cortaría la sesión de
// OpenTok; un diálogo no toca nada: el asesor sigue viendo y oyendo al
// comprador mientras completa envío, dirección y medio de pago. El pedido
// queda vinculado a la llamada (`callRequestId`) y el pago se resuelve en el
// mismo diálogo (ver CheckoutPage con `inCall`).
const InCallCheckoutDialog = ({ open, onClose, storeId, callRequestId, live = false, onPaid }) => (
    <Dialog open={open} onClose={onClose} fullScreen>
        <DialogTitle
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                pr: 1,
                backgroundColor: COLORS.background,
                color: COLORS.text,
            }}
        >
            <span>
                Finalizar compra
                <Typography
                    component="div"
                    sx={{ fontSize: '0.85rem', fontWeight: 400, color: COLORS.muted }}
                >
                    {live
                        ? 'El vivo sigue mientras completás la compra.'
                        : 'La videollamada sigue abierta mientras completás la compra.'}
                </Typography>
            </span>
            <IconButton aria-label={live ? 'Volver al vivo' : 'Volver a la llamada'} onClick={onClose} sx={{ color: COLORS.text }}>
                <CloseIcon />
            </IconButton>
        </DialogTitle>
        <DialogContent sx={{ p: 0, backgroundColor: COLORS.background }}>
            {open && storeId && (
                <ConnectedCheckoutPage
                    key={storeId}
                    storeId={storeId}
                    inCall
                    live={live}
                    callRequestId={callRequestId}
                    onClose={onClose}
                    onPaid={onPaid}
                />
            )}
        </DialogContent>
    </Dialog>
);

export default InCallCheckoutDialog;
